(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mcb-volume-discount-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volume-pricing')) {
    customElements.define(
      'volume-pricing',
      class VolumePricing extends HTMLElement {
        constructor() {
          super();
          this.tiers = this.querySelectorAll('.volume-pricing-tier');
          this.savingsEl = this.querySelector('[data-vp-savings]');
          this.savingsAmountEl = this.querySelector('[data-vp-savings-amount]');
          this.atcBtn = this.querySelector('[data-vp-atc]');
          this.atcTotalEl = this.querySelector('[data-vp-atc-total]');
          this.init();
        }

        init() {
          for (const tier of this.tiers) {
            tier.addEventListener('click', this.handleTierClick.bind(this));
            tier.addEventListener('keydown', this.handleTierKeydown.bind(this));
          }
          if (this.atcBtn) {
            this.atcBtn.addEventListener('click', this.handleAddToCart.bind(this));
          }
          if (this.tiers.length > 0) {
            this.selectTier(this.tiers[0]);
          }
        }

        handleTierClick(event) { this.selectTier(event.currentTarget); }

        handleTierKeydown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.selectTier(event.currentTarget);
          }
        }

        getQuantityInput() {
          const sectionId = this.dataset.sectionId;
          let input = null;
          if (sectionId) input = document.querySelector(`#Quantity-${sectionId}`);
          if (!input) input = document.querySelector('input[name="quantity"]');
          return input;
        }

        handleAddToCart() {
          // Re-use the page's real add-to-cart so the cart drawer + variant logic work.
          const sectionId = this.dataset.sectionId;
          let submit = null;
          if (sectionId) submit = document.querySelector(`#ProductSubmitButton-${sectionId}`);
          if (!submit) submit = document.querySelector('[name="add"]:not([disabled])');
          if (submit) {
            submit.click();
          }
        }

        updateSavings(tier) {
          if (this.savingsEl) {
            const hasSavings = tier.dataset.hasSavings === 'true';
            if (hasSavings && tier.dataset.savings) {
              if (this.savingsAmountEl) this.savingsAmountEl.textContent = tier.dataset.savings;
              this.savingsEl.removeAttribute('hidden');
            } else {
              this.savingsEl.setAttribute('hidden', '');
            }
          }
          if (this.atcTotalEl && tier.dataset.total) {
            this.atcTotalEl.textContent = tier.dataset.total;
          }
        }

        selectTier(selectedTier) {
          for (const tier of this.tiers) {
            tier.classList.remove('is-selected');
            tier.setAttribute('aria-selected', 'false');
          }
          selectedTier.classList.add('is-selected');
          selectedTier.setAttribute('aria-selected', 'true');

          this.updateSavings(selectedTier);

          const quantity = selectedTier.dataset.quantity;
          const quantityInput = this.getQuantityInput();
          if (quantityInput) {
            quantityInput.value = quantity;
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          this.dispatchEvent(new CustomEvent('volume-pricing:tier-selected', {
            bubbles: true,
            detail: { quantity: parseInt(quantity, 10) }
          }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["volume-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('volume-pricing')) {
    customElements.define(
      'volume-pricing',
      class VolumePricing extends HTMLElement {
        constructor() {
          super();
          this.tiers = this.querySelectorAll('.volume-pricing-tier');
          this.init();
        }
    
        init() {
          for (const tier of this.tiers) {
            tier.addEventListener('click', this.handleTierClick.bind(this));
            tier.addEventListener('keydown', this.handleTierKeydown.bind(this));
          }
          
          // Set first tier (quantity 1) as selected by default
          if (this.tiers.length > 0) {
            this.selectTier(this.tiers[0]);
          }
        }
    
        handleTierClick(event) {
          const selectedTier = event.currentTarget;
          this.selectTier(selectedTier);
        }
    
        handleTierKeydown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const selectedTier = event.currentTarget;
            this.selectTier(selectedTier);
          }
        }
    
        selectTier(selectedTier) {
          for (const tier of this.tiers) {
            tier.classList.remove('is-selected');
            tier.setAttribute('aria-selected', 'false');
          }
          selectedTier.classList.add('is-selected');
          selectedTier.setAttribute('aria-selected', 'true');
          
          // Update quantity selector if it exists
          const quantity = selectedTier.dataset.quantity;
          const sectionId = this.dataset.sectionId;
          
          // Use specific selector based on section ID
          let quantityInput = null;
          if (sectionId) {
            quantityInput = document.querySelector(`#Quantity-${sectionId}`);
          }
          
          // Fallback to broader selector if specific one not found
          if (!quantityInput) {
            quantityInput = document.querySelector('input[name="quantity"]');
          }
          
          if (quantityInput) {
            quantityInput.value = quantity;
            // Trigger input and change events so DiscountKit and other listeners can respond
            quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          
          // Dispatch custom event for other components
          this.dispatchEvent(new CustomEvent('volume-pricing:tier-selected', {
            bubbles: true,
            detail: { quantity: parseInt(quantity, 10) }
          }));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
